<template>
  <v-container>
    <v-alert
      v-model="isError"
      dismissible
      type="error"
      transition="fade-transition"
    >
      {{ errMessage }}
    </v-alert>
    <h1>Subscription Holds</h1>
    <v-data-table
      :headers="headers"
      :items="holds"
      :must-sort="true"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.dateAdded }}</td>
        <td>{{ props.item.dateRemoved }}</td>
        <td>
          <v-icon
            small
            @click="deleteHold(props.item)"
            v-if="props.item.dateRemoved === null"
          >delete_forever
          </v-icon>
        </td>
      </template>
    </v-data-table>
    <v-btn @click="addHold">Add Hold</v-btn>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    isError: false,
    errMessage: null,
    holds: [],
    headers: [
      { text: 'Added', value: 'dateAdded' },
      { text: 'Removed', value: 'dateRemoved' },
      { text: 'Actions', value: 'dateAdded' } // no actual value
    ]
  }),
  mounted: function () {
    let id = this.$route.params.id

    // Load information about any holds for this subscription
    this.axios.get('/subscriptions/' + id + '/holds')
      .then((res) => {
        this.holds = res.data
      })
      .catch(this.$root.apiErrorHandler((msg) => {
        this.errMessage = msg
        this.isError = true
      }))
  },
  methods: {
    addHold: function () {
      let id = this.$route.params.id
      this.axios.post('/subscriptions/' + id + '/holds')
        .then((res) => {
          this.$router.push('/admin/subscriptions')
        })
        .catch(this.$root.apiErrorHandler((msg) => {
          this.errMessage = msg
          this.isError = true
        }))
    },
    deleteHold: function (hold) {
      // Confirm with the user that they want to perform the requested action
      // before actually making the request
      confirm('Do you want to remove this hold?') &&
      this.axios.delete('/subscriptions/' + hold.subscriptionID + '/holds')
        .then(() => {
          // Find the index of our hold in the list
          var index = null
          for (var i in this.holds) {
            if (this.holds[i].id === hold.id) {
              index = i
              break
            }
          }
          if (index !== null) {
            // Update the dateRemoved value for this hold
            this.holds[index].dateRemoved = this.$root.getApiDateTimeString()
          } else {
            this.errMessage = 'An error occurred. Please try again.'
            this.isError = true
          }
        })
        .catch(this.$root.apiErrorHandler((msg) => {
          this.errMessage = msg
          this.isError = true
        }))
    }
  }
}
</script>
